import { useEffect } from 'react';
import { useStore } from 'zustand';
import { settingsStore } from '../state/settings';

/** Applies the theme preference as data-theme on <html> (system = follow prefers-color-scheme). */
export function ThemeSync() {
  const theme = useStore(settingsStore, (s) => s.theme);
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', theme);
  }, [theme]);
  return null;
}
